import * as $ from 'jquery';
import Swiper from 'swiper/js/swiper.js'
import ImagesLoaded from 'Imagesloaded'
import Swal from 'sweetalert2'

export default {
  init() {

    const thumbItems = document.querySelectorAll('.product__gallery--thumb a')
    const productGallery = document.querySelector('.swiper-product-gallery')

    const gallery = new Swiper(productGallery, {
      init: false,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 400,
      loop: false,
      effect: 'fade',
      autoHeight: true
    })

    let video = function(vidcontrol){

      const iframe = document.querySelector('.embed-responsive-item')
      const iframeContentWindow = iframe.contentWindow
    
      iframeContentWindow.postMessage(
        `{"event":"command","func":"${vidcontrol}","args":""}`,
        '*'
      )
    }
    
    ImagesLoaded('.product__gallery', () => {
      if (typeof productGallery !== 'undefined' && productGallery != null)
        gallery.init()
    })
    
    gallery.on('slideChange init', () => {
      const el = thumbItems[gallery.realIndex]
      el.classList.add('is-active')
      // video('playVideo')
      // pauseVideo
      Array.prototype.filter.call(el.parentNode.children, child => {
        if (child !== el) child.classList.remove('is-active')
      })
    })

    for (let i = 0; i < thumbItems.length; i++) {
      thumbItems[i].onclick = event => {
        event.preventDefault()
        gallery.slideTo(i, 400, true)
      }
    }

    $('.swiper-wrapper').magnificPopup({
      delegate: 'a.product__gallery-item',
      type: 'image',
      mainClass: 'mfp-with-zoom',
      zoom: {
        enabled: true,
        duration: 300,
        easing: 'ease-in-out',
        opener: function(openerElement) {
          return openerElement.is('img') ? openerElement : openerElement.find('img');
        }
      },
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1] // Will preload 0 - before current, and 1 after the current image
      },
      callbacks: {
        elementParse: function(item) {
          if(item.el.hasClass('product__gallery-item-video')) {
            item.type = 'iframe',
            item.iframe = {
               patterns: {
                 youtube: {
                   index: 'youtube.com/', 
                   id: 'v=',
                   src: '//www.youtube.com/embed/%id%?autoplay=1'
                 }
               }
            }
          } else {
             item.type = 'image',
             item.tLoading = 'Loading image #%curr%...',
             item.mainClass = 'mfp-img-mobile',
             item.image = {
               tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
             }
          }
    
        }
      }
    });

    $('.related.products').each(function(index, el) {

      const t = $(this)

      const swiper = new Swiper( t.find('.related-swiper-container')[0], {
        init: false,
        navigation: {
          nextEl: t.find('.product-nav-next')[0],
          prevEl: t.find('.product-nav-prev')[0],
        },
        loop: false,
        // autoplay: index == 0 ? { delay: 4000 } : false,
        speed: 200,
        grabCursor: true,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 16,
        breakpoints: {
          768: {
            spaceBetween: 30,
          },
  
          1440: {
            spaceBetween: 60,
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
  
          1640: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 110,
            speed: 400,
          }
        },
        on: {
          init: () => {
            if(index != 0 ) {
              t.find('.collapse').collapse('hide')
            }
          },
        }

      })

      ImagesLoaded(t, () => {
        swiper.init()
      })

    })

    $('.ask-price-send').on('click', () => {
      $('.form-ask-price').submit()
    })

    $('.form-ask-price').on( 'submit', function( event ) {

      event.preventDefault();

      const t = $(this);

      $('.ask-price-send').addClass('is-loading');

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: JWD.ajaxurl,
        data: t.serialize(),
        success : function( data ){

          $('.ask-price-send').removeClass('is-loading');
          t.find('.form-group').removeClass('has-error').find('em').remove();

          if (data.errors === true) {

            if ( data.name ) $( '#ask-price-firstname' ).closest('.form-group').addClass('has-error').append('<em>' + data.name + '</em>');
            if ( data.phone ) $( '#ask-price-phone' ).closest('.form-group').addClass('has-error').append('<em>' + data.phone + '</em>');
            if ( data.email ) $( '#ask-price-email' ).closest('.form-group').addClass('has-error').append('<em>' + data.email + '</em>');

          }else{

            t.find('.form-control').val('');

            $('#ask-price').modal('hide')

            Swal.fire({
              title: data.msg,
              html: data.msg_description,
              icon: 'success',
              confirmButtonText: "ตกลง",
              confirmButtonColor: "#000",
            })

          }

        },
        complete: function(data){},
        error : function( err ){}

      });

    });
  },
  finalize() {
  },
}